import { AUDIO_AND_SUBTITLES_PREFERENCES_ACTIONS } from "./actions";

const initialState = {
  audioLanguagePreference: "",
  subtitleLanguagePreference: ""
};

export default function audioAndSubtitlesPreferences(state = initialState, { type, payload }) {
  switch (type) {
    case AUDIO_AND_SUBTITLES_PREFERENCES_ACTIONS.SET_AUDIO_PREFERENCE:
      return { ...state, audioLanguagePreference: payload };
    case AUDIO_AND_SUBTITLES_PREFERENCES_ACTIONS.SET_SUBTITLES_PREFERENCE:
      return { ...state, subtitleLanguagePreference: payload };
    default:
      return state;
  }
}
